<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-datepicker
              id="datepicker-placeholder1"
              v-model="contractDate.fr"
              class="el-def"
              placeholder="계약기간(Fr)"
            />
            <label class="ml-25 mr-50">~</label>
            <b-form-datepicker
              id="datepicker-placeholder2"
              v-model="contractDate.to"
              class="el-def"
              placeholder="계약기간(To)"
            />
            <b-form-input
              v-model="title"
              placeholder="계약명"
              class="el-def"
              @keyup.enter="refetchData()"
            />
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="refetchData()"
            >
              조회
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              계약 리스트 [{{ totalRecords }}] 건
            </h5>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refContractTable"
        primary-key="id"
        :items="fetchContracts"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        selectable
        select-mode="single"
        class="position-relative"
        @row-selected="onRowSelectedContract"
      >
        <template #cell(subCodeCnt)="data">
          <span class="text-nowrap">
            {{ Number(data.value) > 0 ? data.value : '사용안함' }}
          </span>
        </template>
        <template #cell(startDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD') }}
            ~
            {{ data.item.endDate | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
      </b-table>
      <b-pagination
        v-model="currPage"
        :total-rows="totalRecords"
        limit="10"
        per-page="10"
        align="center"
      />
    </b-card>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <feather-icon
              icon="EditIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              상세
            </h4>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-primary"
              @click.prevent="resetContractData()"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>신규 등록</span>
            </b-button>
            <b-button
              variant="primary"
              class="ml-1"
              @click.prevent="saveContract()"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span>저장</span>
            </b-button>
            <b-button
              variant="outline-secondary"
              class="ml-1"
              @click.prevent="removeContract()"
            >
              <feather-icon
                icon="Trash2Icon"
                class="mr-50"
              />
              <span>삭제</span>
            </b-button>
          </b-col>
        </b-row>
        <!-- Edit Form -->
        <validation-observer ref="formRules">
          <b-row class="mt-1">
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="계약명"
                label-for="title"
              >
                <validation-provider
                  #default="{ errors }"
                  name="계약명"
                  rules="required"
                >
                  <b-form-input
                    id="title"
                    v-model="contractData.title"
                    placeholder="계약명을 입력하세요. (최대 15자)"
                    maxlength="15"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="계약 코드 ⓘ 영문 대·소문자는 구분되지 않습니다. (대문자로 통일 권장) "
                label-for="mainCode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="계약 코드"
                  :rules="{ required: true, mainCodeRule }"
                >
                  <b-form-input
                    id="mainCode"
                    v-model="contractData.mainCode"
                    placeholder="10자 이하의 영문자로 입력해 주세요."
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="6"
            >
              <b-form-group
                label="상세 코드 수 ⓘ 계약 수정 시 상세 코드 수를 기존 보다 줄이면, 사용 중인 요양기관 및 통계에 영향을 줄 수 있으니 주의해 주세요."
                label-for="subCodeCnt"
              >
                <validation-provider
                  #default="{ errors }"
                  name="상세 코드 생성"
                  :rules="{ required: true, subCodeRule }"
                >
                  <b-form-input
                    id="subCodeCnt"
                    v-model="contractData.subCodeCnt"
                    type="number"
                    :readonly="subCodeUnUsed"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="4"
            >
              <b-form-checkbox
                v-model="subCodeUnUsed"
                class="custom-control-info"
                style="margin-top: 30px;"
                @change="changeSubCodeUnUsed"
              >
                사용안함
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <label>계약 기간 ⓘ 계약 수정 시 계약 기간을 변경하면, 등록된 게시글에 영향을 줄 수 있으니 주의해 주세요.</label>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="계약기간(Fr)"
                :rules="{
                  required: true,
                  before: contractData.endDate
                }"
              >
                <b-form-datepicker
                  v-model="contractData.startDate"
                  placeholder="계약기간(Fr)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('required')
                      ? '[계약 기간(Fr)]는(은) 필수 입력입니다.'
                      : failedRules.hasOwnProperty('before')
                        ? '계약기간(To) 이전이어야 합니다.'
                        : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="계약기간(To)"
                :rules="{
                  required: true,
                  after: contractData.startDate
                }"
              >
                <b-form-datepicker
                  v-model="contractData.endDate"
                  placeholder="계약기간(To)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('required')
                      ? '[계약 기간(To)]는(은) 필수 입력입니다.'
                      : failedRules.hasOwnProperty('after')
                        ? '계약기간(Fr) 이후여야 합니다.'
                        : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "@axios"
import { ref, watch, getCurrentInstance } from "@vue/composition-api"
import { useToast } from "vue-toastification/composition"
import { required } from "@validations"
import { ValidationProvider, ValidationObserver, extend } from "vee-validate"
import { errorFormatter } from "@core/utils/filter"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },

  setup() {
    const toast = useToast()
    const instance = getCurrentInstance()
    const bvModal = instance.proxy.$bvModal
    const refs = instance.proxy.$refs
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const mainCodeRule = extend('mainCodeRule', {
      validate: value => /^[A-Za-z]{1,10}$/.test(value),
      message: '10자 이하의 영문자만 입력할 수 있습니다.',
    })
    const subCodeRule = extend('subCodeRule', {
      validate: value => {
        const num = Number(value)
        return (
          Number.isInteger(num) && num >= 0 && num <= 998
        )
      },
      message: '998이하의 숫자만 입력할 수 있습니다.',
    })

    const title = ref("")
    const contractDate = ref({ fr: null, to: null })

    // Main Table Config
    const contractInitState = {
      id: 0,
      title: "",
      mainCode: "",
      subCodeCnt: null,
      startDate: null,
      endDate: null,
    }
    const contractData = ref({ ...contractInitState })

    const resetContractData = () => {
      Object.assign(contractData.value, contractInitState)
      subCodeUnUsed.value = false
      refs.formRules.reset()
    }

    watch(() => contractData.value.subCodeCnt, newVal => {
      if (String(newVal) === '0') {
        subCodeUnUsed.value = true
      } else {
        subCodeUnUsed.value = false
      }
    }, { immediate: true })

    const subCodeUnUsed = ref(false)
    const changeSubCodeUnUsed = () => {
      if (subCodeUnUsed.value) {
        contractData.value.subCodeCnt = 0
      } else {
        contractData.value.subCodeCnt = null
      }
    }

    const refContractTable = ref(null)
    const sortBy = ref("createDate")
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      { key: "title", label: "계약명", sortable: false },
      { key: "mainCode", label: "계약 코드", sortable: false },
      { key: "subCodeCnt", label: "상세 코드 수", sortable: false },
      { key: "startDate", label: "계약 기간", sortable: false },
      { key: "createUserName", label: "등록자", sortable: false },
    ]
    const refetchData = () => {
      refContractTable.value.refresh()
    }
    watch([currPage], () => {
      refetchData()
    })
    const onRowSelectedContract = items => {
      const item = items[0]
      if (item) {
        getContract(item.id)
      }
    }
    // Main Table Config End.

    const fetchContracts = (ctx, callback) => {
      axios
        .post("/fa/desk-contract/list", {
          search: {
            title: title.value,
            contractDateFr: contractDate.value.fr
              ? `${contractDate.value.fr}T00:00:00`
              : null,
            contractDateTo: contractDate.value.to
              ? `${contractDate.value.to}T23:59:59`
              : null,
          },
          sort: {
            predicate: sortBy.value,
            reverse: isSortDesc.value,
          },
          pagination: {
            number: currPage.value,
          },
        })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const getContract = id => {
      axios
        .get(`/fa/desk-contract/${id}`)
        .then(rs => {
          contractData.value = rs.data
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const saveContract = () => {
      const validPromise = refs.formRules.validate()
      validPromise.then(valid => {
        if (!valid) return

        const { id } = contractData.value
        if (id) {
          updateContract()
        } else {
          saveNewContract()
        }
      })
    }

    const saveNewContract = () => {
      axios
        .put("/fa/desk-contract/new", contractData.value)
        .then(rs => {
          pushToast('success', '신규 계약 등록 완료')
          if (rs.data.id) {
            contractData.value.id = rs.data.id
          }
          resetContractData()
          refetchData()
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "데이터를 저장하는 과정에서 오류가 발생하였습니다."))
        })
    }

    const updateContract = () => {
      axios
        .patch(
          `/fa/desk-contract/update/${contractData.value.id}`,
          contractData.value,
        )
        .then(() => {
          pushToast('success', '데이터 변경 완료')
          refetchData()
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "데이터를 변경하는 과정에서 오류가 발생하였습니다."))
        })
    }

    const removeContract = () => {
      if (!contractData.value.id) {
        pushToast('warning', "삭제할 대상을 선택하세요.")
        return
      }
      bvModal
        .msgBoxConfirm("삭제 하시겠습니까?", {
          size: "sm",
          cancelVariant: "outline-secondary",
          centered: true,
        })
        .then(confirm => {
          if (!confirm) return

          axios
            .delete(`/fa/desk-contract/${contractData.value.id}`)
            .then(() => {
              pushToast('success', '데이터 삭제 완료')
              refetchData()
              resetContractData()
            })
            .catch(error => {
              const { response: { status, data } } = error
              if (status === 400 && data === 'ADM_CNT_TP02') {
                pushToast('danger', '해당 계약으로 설정된 게시글이 있어 삭제할 수 없습니다.')
              } else {
                pushToast('danger', errorFormatter(error, "삭제하는 과정에서 오류가 발생하였습니다."))
              }
            })
        })
    }

    return {
      title,
      contractDate,
      tableColumns,
      refContractTable,
      sortBy,
      isSortDesc,
      refetchData,
      currPage,
      totalRecords,
      contractData,
      resetContractData,
      onRowSelectedContract,

      required,
      mainCodeRule,
      subCodeRule,
      fetchContracts,
      getContract,
      saveContract,
      removeContract,
      subCodeUnUsed,
      changeSubCodeUnUsed,
    }
  },
}
</script>

<style lang="scss" scoped></style>
